/** The reference "You are disconnected." panel, shown when the session is gone. */
export function Disconnected() {
  return (
    <div id="disconnected" style={{ display: 'block' }}>
      <div className="closediv">
        <div className="icondiv" />
        <div className="titlediv">You are disconnected.</div>
        <div className="bodydiv">Please login again.</div>
        <a href="#" onClick={(e) => { e.preventDefault(); window.close() }} className="btn btn-primary btn-floating btn-lg btn-block">Close</a>
      </div>
    </div>
  )
}
